import { AxiosResponse } from 'axios';
import { MunicipalityFormVM } from 'civil-status/view-models/municipality-form';
import { DateTime } from 'luxon';
import { HttpResponse } from 'shell/models/http-response';
import { ValueDomainType } from 'shell/models/value-domain-type';

export const transformerMunicipalityData = (
  response: AxiosResponse<HttpResponse<ValueDomainType>>
): MunicipalityFormVM => {
  const dataResponse = (response.data?.payload || {}) as ValueDomainType;

  return {
    institution: dataResponse.key?.codEnte || '',
    id: dataResponse.key?.idValore || '',
    idAnsc: dataResponse?.idValoreAnsc || '',
    dateFrom: dataResponse.dataInizioValidita
      ? DateTime.fromISO(dataResponse.dataInizioValidita)
      : null,
    dateTo: dataResponse.dataFineValidita ? DateTime.fromISO(dataResponse.dataFineValidita) : null,
    order: dataResponse.numOrdinamento || undefined,
    description: dataResponse.valore?.trim() || '',
    note: dataResponse.note || '',
    anscMunicipality: null,
  };
};
